<template>
  <div class="div-top20">

    <div v-if="up=== true  ">
      <a href="javascript:void(0);" @click="setroters('+1')">上一篇</a>
    </div>
    <div v-if="down=== true  ">
      <a href="javascript:void(0);" @click="setroters('-1')">下一篇</a>
    </div>
  </div>

</template>
<script>
  export default {
    props: ['up', "down", "updown", "downnew", "maxid", "id"],
    inject: ['reload'],
    data() {
      return {};
    },
    methods: {
      setroters(val) {
        let src = ""
        let indexid = 0
        let zup = false;
        let zdown = false;
        if (val == '-1') {
          if (parseInt(this.id) - 1 == 1) {
            indexid = this.id - 1
            zup = true;
            zdown = false;
          } else if (parseInt(this.id) - 1 > 1) {
            indexid = parseInt(this.id) - 1
            zup = true;
            zdown = true;
          }
        } else {
          if (parseInt(this.id) + 1 === parseInt(this.maxid)) {
            indexid = parseInt(this.id) + 1
            zup = false;
            zdown = true;
          } else if (parseInt(this.id ) + 1< parseInt(this.maxid)) {
            indexid = parseInt(this.id) + 1
            zup = true;
            zdown = true;
          }
        }
        src = "news" + indexid
        this.$router.push({
          path: 'newscontent',
          query: {
            news: src,
            up: zup,
            down: zdown,
            updown: this.updown,
            downnew: this.downnew,
            maxid: this.maxid,
            id: indexid
          }
        })
        this.reload();
      },
    },
  };

</script>
<style scoped>
  .div-top20 {
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/commoncoms/upanddown.vue